import { useState } from 'react';
import { useList } from '@refinedev/core';
import { DataTable, type Column } from '../../../components/DataTable.js';
import { ReportFilterBar } from '../../../components/ReportFilterBar.js';

interface DepositsHeldRow {
  propertyId: string;
  propertyName: string;
  leaseCount: number;
  depositBalance: string;
}

const columns: Column<DepositsHeldRow>[] = [
  { key: 'property', header: 'Property', render: (r) => r.propertyName },
  { key: 'count', header: 'Leases', numeric: true, render: (r) => r.leaseCount },
  { key: 'balance', header: 'Deposits held', numeric: true, render: (r) => `$${r.depositBalance}` },
];

export function DepositsHeld({
  ownerId,
  onOwnerChange,
}: {
  ownerId: string;
  onOwnerChange: (value: string) => void;
}) {
  const [propertyId, setPropertyId] = useState('');

  const { data, isLoading, error } = useList<DepositsHeldRow>({
    resource: 'reports/deposits-held',
    pagination: { mode: 'off' },
    filters: [
      { field: 'propertyId', operator: 'eq', value: propertyId || undefined },
      { field: 'ownerId', operator: 'eq', value: ownerId || undefined },
    ],
  });

  return (
    <div className="stack">
      <p className="muted">
        Security deposits currently held, by property — reconcilable to the regulated deposit
        account (MCL 554.602). Derived from unreversed allocations, same as every other ledger
        figure — never a separate balance to keep in sync.
      </p>

      <ReportFilterBar
        propertyId={propertyId}
        onPropertyChange={setPropertyId}
        ownerId={ownerId}
        onOwnerChange={onOwnerChange}
        exportPath="/reports/deposits-held"
        exportParams={{ propertyId: propertyId || undefined, ownerId: ownerId || undefined }}
      />

      <DataTable
        columns={columns}
        rows={data?.data ?? []}
        rowKey={(row) => row.propertyId}
        isLoading={isLoading}
        error={error}
        emptyMessage="No deposits currently held."
      />
    </div>
  );
}
